type ImageProps = React.DetailedHTMLProps<
  React.ImgHTMLAttributes<HTMLImageElement>,
  HTMLImageElement
> & {
  fileName?: string | undefined;
  alt: string;
};

const Image: React.FC<ImageProps> = (p) => {
  const { fileName, alt, src, ...props } = p;

  return (
    <img
      {...props}
      src={src ? src : `/assets/images/${fileName}`}
      alt={alt}
    />
  );
};

export default Image;
